export default {
    importEmployeeData: 'ผลการนำเข้ารายชื่อพนักงาน',
    importEmployee: 'นำเข้าพนักงาน',
    importImage: 'นำเข้ารูปภาพ',
    fileInput: 'ไฟล์ที่นำเข้า',
    msgUploadExcel: 'อัพโหลดข้อมูลไฟล์ excel',
    msgUploadZip: 'อัพโหลดข้อมูลเเบบ zip ไฟล์',
    note: 'หมายเหตุ',
    msgImportExcel: 'ต้องเป็นไฟล์ประเภท excel',
    msgImportImageA: 'ต้องเป็นประเภทไฟล์ zip ที่มีขนาดไม่เกิน 500 MB',
    msgImportImageB: 'ไฟล์ zip ไม่รวมอยู่ในโฟลเดอร์ใดโฟลเดอร์หนึ่ง',
    msgImportImageC: 'ได้เฉพาะภาพที่เป็น jpeg/png ในไฟล์ zip เท่านั้น',
    msgImportImageD: 'รูปภาพเเต่ละรูปมีขนาดห้ามเกิน 200 KB',
    submit: 'ส่ง',
    cancel: 'ยกเลิก',
    close: 'ปิด',
    download: 'ดาวโหลด',
    total: 'จำนวนทั้งหมด',
    importEmployeeSuccess: 'จำนวนรายชื่อที่สำเร็จ',
    imageUploadFailed: 'จำนวนรายชื่อที่ไม่สำเร็จ',
    employeeIdNotFound: 'ไม่พบรหัสพนักงานในระบบ',
    employeeIdDuplicate: 'รหัสพนักงานซ้ำกัน',
    invalidImageType: 'ประเภทไฟล์รูปภาพไม่ถูกต้อง',
    invalidImageSize: 'ขนาดไฟล์รูปภาพไม่ถูกต้อง',
    unableToImageDevice: 'ไม่สามารถนำรูปภาพเข้าอุปกรณ์',
    pleaseReUploadTheFailed: 'กรุณาแก้ไขและอัปโหลดไฟล์อีกครั้ง',
    moreDetails: 'ดูรายละเอียด'
}
